import { generateUtilityClasses } from '@mui/material';

export const checkboxItemClasses = generateUtilityClasses('CheckboxItem', [
  'root',
  'checkbox',
  'label',
  'text',
  'status',
  'infoButton',
]);
